import { render } from "./PieChartTemplate.vue?vue&type=template&id=26a4b5e6"
import script from "./PieChartTemplate.vue?vue&type=script&lang=js"
export * from "./PieChartTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/chart-building/chart_templates/PieChartTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26a4b5e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26a4b5e6', __exports__)) {
    api.reload('26a4b5e6', __exports__)
  }
  
  module.hot.accept("./PieChartTemplate.vue?vue&type=template&id=26a4b5e6", () => {
    api.rerender('26a4b5e6', render)
  })

}


export default __exports__